import * as bootstrap from 'bootstrap';
import { BlockPastDates } from 'smg/form';
import i18n from '../i18n';

export interface AdditionalDetailsHandle {
    // Snapshot of the current form state, shaped for the submit handler to
    // fold into the order-create body. The admin /orders endpoint accepts
    // every field on the draft: eventDate, notes (posted as a Sales-
    // addressed order event), promotionalApproval, sms.
    snapshot(): AdditionalDetailsDraft;
}

export interface AdditionalDetailsDraft {
    // Empty when "No" is picked. Format is yyyy-mm-dd (HTML5 date input),
    // which is exactly what the admin /orders endpoint's
    // `datetime=2006-01-02` binding expects.
    eventDate: string;
    notes: string;
    // Defaults to false — admin must explicitly opt the customer in for
    // either of these. SMS in particular has a callout in the UI: leaving
    // it unchecked does NOT opt the customer out, it just leaves their
    // existing preference untouched.
    promotionalApproval: boolean;
    sms: boolean;
}

export function SetupAdditionalDetails(): AdditionalDetailsHandle {
    const $clearBtn = document.getElementById('additional-clear') as HTMLButtonElement;

    const $eventYes = document.getElementById('additional-event-yes') as HTMLInputElement;
    const $eventNo = document.getElementById('additional-event-no') as HTMLInputElement;
    const $eventDateCollapse = document.getElementById('additional-event-date-collapse') as HTMLFieldSetElement;
    const $eventDate = document.getElementById('additional-event-date') as HTMLInputElement;

    const $notes = document.getElementById('additional-notes') as HTMLTextAreaElement;
    const $marketing = document.getElementById('additional-marketing') as HTMLInputElement;
    const $sms = document.getElementById('additional-sms') as HTMLInputElement;

    const eventDateCollapse = bootstrap.Collapse.getOrCreateInstance($eventDateCollapse, { toggle: false });

    // This was the pattern BlockPastDates was extracted from (#5144); the
    // helper owns min-stamping, past-date validity, and midnight rollover now.
    const revalidateEventDate = BlockPastDates($eventDate, { message: i18n('eventDatePast') });

    function syncEventDate() {
        if ($eventYes.checked) {
            eventDateCollapse.show();
            // Fieldset disabled gates the date input's `required` so HTML5
            // validation only kicks in when the admin actually said "Yes".
            $eventDateCollapse.disabled = false;
        } else {
            eventDateCollapse.hide();
            $eventDateCollapse.disabled = true;
        }
        // The disabled flip flows into validity either way: re-selecting Yes
        // re-checks the date it was holding, hiding drops the stale message
        // and is-invalid marker so they can't survive the collapse.
        revalidateEventDate();
    }

    $eventYes.addEventListener('change', syncEventDate);
    $eventNo.addEventListener('change', syncEventDate);

    $clearBtn.addEventListener('click', () => {
        $eventYes.checked = true;
        $eventNo.checked = false;
        $eventDate.value = '';
        $notes.value = '';
        $marketing.checked = false;
        $sms.checked = false;
        syncEventDate();
    });

    return {
        snapshot: () => ({
            eventDate: $eventYes.checked ? $eventDate.value : '',
            notes: $notes.value.trim(),
            promotionalApproval: $marketing.checked,
            sms: $sms.checked,
        }),
    };
}
